import { type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { LocaleSwitcher } from 'receivable-invoices-js/react/components/shared/locale-switcher';
import { QontoHeader } from 'receivable-invoices-js/react/components/shared/qonto-header';
import styles from '../responsive-view.module.css';

interface DocumentHeaderProps {
  isDesktop: boolean;
  isClientPortalEnabled?: boolean;
  clientPortalId?: string;
}

export function DocumentHeader({
  isDesktop,
  isClientPortalEnabled,
  clientPortalId,
}: DocumentHeaderProps): ReactNode {
  return (
    <div className={styles.header} role={!isDesktop ? 'banner' : undefined}>
      <QontoHeader className={styles.qontoHeader} data-testid="qonto-header" />
      <div className={styles.headerInner}>
        <LocaleSwitcher data-testid="locale-switcher" />
        {isClientPortalEnabled ? (
          <a
            className="btn"
            data-test-client-portal-cta
            data-testid="client-portal-cta"
            href={`/clients/${clientPortalId || ''}`}
            type="button"
          >
            <FormattedMessage id="quote.preview.cta.portal" />
          </a>
        ) : null}
      </div>
    </div>
  );
}
